import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("circle", {
  cx: "6.18",
  cy: "17.82",
  r: "2.18"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 10.1v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9zm0-5.66v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56z"
})), 'RssFeedSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/RssFeedSharp.js
// module id = 5871
// module chunks = 2